module.exports = __webpack_public_path__ + "69567ea587e87cdf883fe2aa36529685.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/solo-right-19.png
// module id = 3033
// module chunks = 0